import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  buttonWrapper: {
    "& span": {
      fontWeight: 600,
      marginLeft: "10px",
    },
    "& svg": {
      fill: "#fff",
    },
  },
}));